const SvgPageNoIcon = props => <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" {...props} />;
export default SvgPageNoIcon;